import { IDeleteMotivoAfastamentoUseCase } from "../../../presentation/useCases/delete/delete_motivo_afastamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteMotivoAfastamentoUseCase
 */

export class DeleteMotivoAfastamentoUseCase implements IDeleteMotivoAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteMotivoAfastamento(
    idMotivoAfastamento: number,
  ): Promise<void> {
    await this.repository.deleteMotivoAfastamento(
      idMotivoAfastamento,
    );
  }
}